import { createSlice } from "@reduxjs/toolkit";

const consultarauthState = {
  dataconsultarauth: [],
};

const consultarauthSlice = createSlice({
  name: "consultarauth",
  initialState: consultarauthState,
  reducers: {
    StoreConsultarAuth: (state, actions) => actions.payload,

    AnularAuth: () => consultarauthState,
  },
});

export const { StoreConsultarAuth, AnularAuth } = consultarauthSlice.actions;

export default consultarauthSlice.reducer;
